import axios from "axios";
import type { UserProfile } from "@/models/userProfile";
import type { TrustGroup } from "@/models/trustGroup";

export const getUserProfile = async (email: string): Promise<UserProfile> => {
  const response = await axios.get("/api/admin/user-profile", {
    params: {
      email: email,
    },
  });
  return response.data;
};

export const updateTrustGroup = async (
  trustGroup: TrustGroup
): Promise<void> => {
  const response = await axios.put("/api/admin/trust-group/update", trustGroup);
  return response.data;
};

export const createUserProfile = async (
  userProfile: UserProfile
): Promise<void> => {
  await axios.post("/api/admin/user-profile", userProfile);
};

export const updateUserProfile = async (
  userProfile: UserProfile
): Promise<UserProfile> => {
  const response = await axios.put("/api/admin/user-profile", userProfile);
  return response.data;
};

export const updateUserRole = async (
  userProfile: UserProfile
): Promise<UserProfile> => {
  const response = await axios.put("/api/admin/user-profile/role", userProfile);
  return response.data;
};

export const removeUserFromTrustGroup = async (
  userProfile: UserProfile,
  trustGroupId: string
): Promise<void> => {
  const response = await updateUserProfile(userProfile);
};

export const deleteUserProfile = async (email: string): Promise<void> => {
  await axios.delete("/api/admin/user-profile", {
    params: {
      email: email,
    },
  });
};

export const lockOutUserProfile = async (
  userProfile: UserProfile
): Promise<UserProfile> => {
  const response = await axios.put("/api/admin/user-profile/lock", userProfile);
  return response.data;
};

export const unlockUserProfile = async (
  userProfile: UserProfile
): Promise<UserProfile> => {
  const response = await axios.put(
    "/api/admin/user-profile/unlock",
    userProfile
  );
  return response.data;
};

export const unlockAndResetSuspensionUserProfile = async (
  email: string
): Promise<UserProfile> => {
  const response = await axios.put(
    "/api/admin/user-profile/unlock-and-reset-suspension",
    {},
    {
      params: {
        email: email,
      },
    }
  );
  return response.data;
};
